import { Show, type JSX } from "solid-js";

export default function Section(props: {
  header?: string;
  footer?: string;
  children: JSX.Element;
  class?: string;
}) {
  return (
    <section class={`tg-section-wrap ${props.class ?? ""}`.trim()}>
      <Show when={props.header}>
        <h2 class="tg-section-header">{props.header}</h2>
      </Show>
      <div class="tg-section">{props.children}</div>
      <Show when={props.footer}>
        <p class="tg-section-footer">{props.footer}</p>
      </Show>
    </section>
  );
}
